import React from 'react';
import './About.css';

function About({ onIconClick }) {
  return (
    <div className="about-container">
      <div className="about-content">
        <button className="about-icon-btn" onClick={onIconClick} aria-label="Back to home">
          <div className="brand-badge about-badge">
            <span className="brand-open">open</span>
            <span className="brand-flex">flex</span>
          </div>
        </button>
        <div className="about-textbox">
          <p>public camera & ip finder by flex</p>
          <p>*this is a tool for fun & time saving purposes whenever info about ip adresses is needed. You want your tailored solution?</p>
          <p><a href="https://otonio.de" target="_blank" rel="noopener noreferrer">you can find me right here (use any language)</a></p>
        </div>
      </div>
    </div>
  );
}

export default About;
